import './kitchenmouse/style';
import FormStructure from './kitchenmouse/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/inquiry-renderer/client_forms/includes.js